import React from 'react';
import { withRouter } from 'react-router-dom';

import InProgressContainer from 'containers/InProgressContainer';
import ShopContainer from 'containers/ShopContainer';
import UnauthorizedContainer from 'containers/UnauthorizedContainer';

import { Container, Item, Row } from 'components/Layout';
import { Column, Grid, Switch, Wrapper } from 'components/LayoutApp';
import Visibilities from 'components/Visibilities';

import ConfigContainer from './containers/menus/ConfigContainer';
import CpmFormatContainer from './containers/menus/CpmFormatContainer';
import MediaCategoriesContainer from './containers/menus/MediaCategoriesContainer';
import NewsletterContainer from './containers/menus/NewsletterContainer';
import ShopGroupContainer from './containers/menus/ShopGroupContainer';
import SidebarContainer from './containers/SidebarContainer';
import { useNavigation } from './contexts/NavigationContext';

const App = () => {
  const { menu, showMenu } = useNavigation();
  const getContainer = () => {
    const menuName = menu.name;
    if (!menu.enabled) {
      return <UnauthorizedContainer />;
    }

    switch (menuName) {
      case 'config':
        return <ConfigContainer />;
      case 'shop':
        return <ShopContainer />;
      case 'newsletter':
        return <NewsletterContainer />;
      case 'shopGroup':
        return <ShopGroupContainer />;
      case 'formatCPM':
        return <CpmFormatContainer />;
      case 'mediaCategory':
        return <MediaCategoriesContainer />;
      default:
        return <InProgressContainer text={menuName} />;
    }
  };

  return (
    <Wrapper>
      <Grid>
        <Column>
          <SidebarContainer />
        </Column>
        <Column verticalySpaced>
          <Visibilities>
            <Switch>
              <Container>
                <Row spacing={0}>
                  <Item
                    alignItems="flex-start"
                    show={showMenu}
                    style={{ paddingRight: '8px' }}
                  >
                    {getContainer()}
                  </Item>
                </Row>
              </Container>
            </Switch>
          </Visibilities>
        </Column>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(App);
